module.exports = __webpack_public_path__ + "web_static/img/SuiteImage.064e07cf.png";